import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT } from "./apiRoutes";

const mutateAddApproveDoc = async ({
  documentId,
  data,
}: {
  documentId: string;
  data: any;
}) => {
  return await axiosAuth.post(`${PARK_DOCUMENT}/${documentId}/approve`, data);
};

const useAddApproveDocMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      documentId: string;
      data: any;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddApproveDoc,
    ...queryParams,
  });

export default useAddApproveDocMutation;
